import { provideNativeDateAdapter } from '@angular/material/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';
import * as Sentry from "@sentry/angular";
import 'hammerjs';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

// Disable console logs in production
if (environment.production && !Capacitor.isNativePlatform()) {
  globalThis.console.log = () => { };
  globalThis.console.warn = () => { };
  globalThis.console.error = () => { };
  globalThis.console.debug = () => { };
  globalThis.console.info = () => { };
}

Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.sentryEnvironment,
  release: environment.sentryRelease,
  enabled: environment.sentryEnabled,
  integrations: [Sentry.browserTracingIntegration()],
  sendDefaultPii: false,
  tracesSampleRate: environment.sampleRate,
});

bootstrapApplication(AppComponent, {
  providers: [
    appConfig.providers,
    provideNativeDateAdapter(),
  ]
})
  .catch((err) => console.error(err));
